<template>
  <div class="container-fluid pt-0 mt-0">
    <AddDestination
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      @showSuccessPopup="handleSuccessPopup"
      :isAddressRequired="true"
      type="origin"
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <DeleteModal
      :show="showDelete"
      @submit="doDelete"
      @close="closeDelete"
      :name="$t('origin')"
    />

    <EditOrigin
      v-if="editOriginModal"
      :show="editOriginModal"
      v-on:closeEditOriginModal="editOriginModal = false"
      :origin="editedOrigin"
      @showSuccessPopup="handleSuccessPopup"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />

    <div
      style="
        background-color: #fff;
        max-height: 40rem;
        overflow-y: auto;
        width: 100%;
        height: fit-content;
      "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="header d-flex justify-content-between align-items-center">
          <p>{{ $t("orign") }}</p>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      >
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="user-row"
                    style="border-bottom: unset"
                    :key="index"
                    v-for="(origin, index) in paginatedData"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td style="text-transform: capitalize">
                      {{ origin.name }}
                    </td>

                    <td>{{ origin.address.name }}</td>

                    <td>{{ origin.region }}</td>

                    <td style="display: flex; align-items: center; gap: 8px">
                      {{ origin.country }}
                    </td>

                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click="editorigin(origin)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="openDelete(origin.id)"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TableSearch from "../../../components/TableSearch.vue";
import tableMixin from "../../../mixins/tableMixinWithBackend";
import Pagination from "../../../components/PaginationNew.vue";
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../../components/Iconsvg/IconDeleteUser.vue";

import AddDestination from "../../Modals/AddDestination.vue";
import DeleteModal from "../../Modals/DeleteModal.vue";
import EditOrigin from "../../Modals/EditOrigin.vue";
import SuccessModal from "../../Modals/SuccessModal.vue";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

import loadGoogleMapsApi from "load-google-maps-api";

export default {
  name: "ExportDispatchOrigin",

  mixins: [tableMixin],

  components: {
    Pagination,
    TableSearch,
    IconEdit,
    IconDelete,
    DeleteModal,
    EditOrigin,
    Loading,
    SuccessModal,
    AddDestination,
  },

  mounted() {
    this.fetchExportDispatchOrigin(this.params);

    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    });
  },

  props: {
    showModal: Boolean,
    closeModal: Function,
  },

  data() {
    return {
      isLoading: true,
      fullPage: true,
      showDelete: false,
      editOriginModal: false,
      dataTable: [],
      sortOrders: {},
      showSuccessPopup: false,
      successMsg: "",
      successHeading: "",
      editedOrigin: [],
    };
  },

  computed: {
    ...mapGetters(["meta", "origins"]),

    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("name"), "name"],
        [this.$t("address"), "address"],
        [this.$t("region"), "region"],
        [this.$t("country"), "country"],
        [this.$t("action"), "column2"],
      ];
    },
  },

  methods: {
    ...mapActions(["getOrigin", "addOrigin", "deleteOrigin"]),

    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    closeDelete() {
      this.showDelete = false;
    },
    doDelete() {
      this.isLoading = true;

      this.deleteOrigin(this.id).then(() => {
        this.getOrigin();
        this.isLoading = false;
        this.showDelete = false;

        this.showSuccessPopup = true;

        this.successMsg = this.$t("deleted_origin_mssg");
        this.successHeading = this.$t("deleted_origin_heading");
      });
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    editorigin(OriginInfo) {
      this.editedOrigin = [OriginInfo];
      this.editOriginModal = true;
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };
      this.fetchExportDispatchOrigin(params);
    },
    fetchExportDispatchOrigin(params) {
      this.isLoading = true;
      this.getOrigin(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    origins: {
      handler: function () {
        this.dataTable = this.origins;
      },
      deep: true,
    },
    params() {
      this.fetchExportDispatchOrigin(this.params);
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.header > p {
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  color: rgba(64, 74, 87, 1);
  margin-top: 1rem;
}
</style>
